/**
 * Created by Ivan on 24.05.2025
 */

const SharkTutorial = function () {
    return new TutorialScenario(SharkTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(SharkTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(SharkTutorial.NAME);
            Game.currentGame.hand.setCards(SharkTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(SharkTutorial.NAME)
    });
};

SharkTutorial.NAME = "shark";
SharkTutorial.CONFIG = {
    handValues: ["2"],
    importantCards: [SharkCard],
    force: "SharkTutorialMessage",
    filter: ["3", SharkCard]
};
